export default __webpack_public_path__ + "ffdf4480f915f5b33e6569ac6382f4fc.png";